import "./App.css";
import { GlobalStyle, theme } from "./styles";
import Navbar from "./components/Navbar/Navbar";
import Layout from "./components/Layout/Layout";
import About from "./sections/About/About";
import Projects from "./sections/Projects/Projects";
import HappyClients from "./sections/HappyClients/HappyClients";
import Testimonials from "./sections/Testimonials/Testimonials";
import Contact from "./sections/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { ThemeProvider } from "styled-components";

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Navbar />
        <Layout>
          <About />
          <Projects />
          <HappyClients />
          <Testimonials />
          <Contact />
        </Layout>
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
